<template>
    <ul class="category_list d-flex flex-wrap" v-animate="'slide-in-up'">
        <li>
            <a href="#" class="category_anchor" :class="{active: currentFilter == ''}" v-on:click="setFilter('')">すべて</a>
        </li>
        <li v-for="(category, index) in categories" :key="index">
            <a href="#" class="category_anchor" :class="{active: currentFilter == category}" v-on:click="setFilter(category)">{{ category }}</a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'WorksCategory',
    props: {
        setFilter: Function,
        currentFilter: String
    },
    data() {
        return {
            categories: [],
            coun: []
        }
    },
    created() {
        this.axios.get('/global-works/works.json').then( res => {
            for(let i=0; i<res.data.length; i++) {
                this.categories.push(res.data[i].categories[0])
                this.coun.push(res.data[i].country)
            }
            this.categories = [...new Set(this.categories)]
            this.coun = [...new Set(this.coun)]
            this.coun.map( item => {
                switch (item) {
                    case 'JP':
                        this.categories.push('日本');
                        break;
                    case 'CN':
                        this.categories.push('中国');
                        break;
                    case 'EN':
                        this.categories.push('英国');
                        break;
                    case 'TW':
                        this.categories.push('台湾');
                        break;
                    case 'MA':
                        this.categories.push('マレーシア');
                        break;
                    case 'VN':
                        this.categories.push('ベトナム');
                        break;
                    case 'TH':
                        this.categories.push('タイ');
                        break;
                    case 'SP':
                        this.categories.push('シンガポール');
                        break;
                }
            })
        })
    }
}
</script>

<style lang="scss" scoped>
    @keyframes slide-in-up {
        0% {
            visibility: visible;
            opacity: 0;
            transform: translate3d(0,50%,0);
        }

        to {
            visibility: visible;
            opacity: 1;
            transform: translateZ(0);
        }
    }

    .animate {
        visibility: hidden;
    }

    .animate-active.slide-in-up {
        animation: slide-in-up .7s ease-out;
        animation-fill-mode: forwards;
        animation-delay: 4s;
    }

    .category_list {
        max-width: 1051px;
        margin: -50px auto 86px auto;
        padding-left: 0;
        > li {
            list-style: none;
            margin-top: 48px;
            margin-left: 7.5%;

            &:first-child .category_anchor {
                color: #000000;
            }
        }
    }

    .category_anchor {
        color: #999999;
        position: relative;
        transition: color .3s ease-in-out;

        &::before {
            content: "";
            position: absolute;
            display: block;
            width: 100%;
            height: 1px;
            bottom: -5px;
            left: 0;
            background-color: #000000;
            transform: scaleX(0);
            transform-origin: top left;
            transition: transform 0.25s ease-out;
        }

        &:hover {
            color: #000000;
            &::before {
                transform: scaleX(1);
            }
        }
        &.active {
            color: #000000;
            &::before {
                transform: scaleX(1);
            }
        }
    }

    .sub-navbar .lang a.nav-link > span::before {
        content: "";
        position: absolute;
        display: block;
        width: 100%;
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #FFF;
        transform: scaleX(0);
        transform-origin: top left;
        transition: transform 0.2s ease-out;
        -webkit-transition: transform 0.2s ease-out;
    }

    @media screen and (max-width: 767px) {
        .category_list {
            > li:first-child {
                width: 100%;
            }
        }
    }
</style>
